<template>
  <div class="page-examine-content" :class="{'page-examine__renzheng': isAuthentication}">
    <li class="page-info-item" v-if="info.type === 'info'">
      <label class="page-info-tit">{{info.label}}:</label>
      <div class="page-info-val" :title="info.value">
        <span class="page-info-val__name page-info-val__text">{{info.value}}</span>
      </div>
    </li>
    <li class="page-info-item" v-if="info.type=== 'img'">
      <label class="page-info-tit">{{info.label}}:</label>
      <div class="page-info-val">
        <div class="page-info-val-img">
          <div v-if="isAuthentication" class="page-info-val__name" :title="info.imgName">
            {{info.imgName}}
          </div>
          <img v-else :src="info.value" alt="未找到">
          <div class="img-ope">
            <a @click="lookFullImg(info.value)" class="verify-look" href="javascript:;">查看</a>
            <a class="download_img" href="javascript:;" @click.stop="downloadImg(info)">下载</a>
          </div>
        </div>
      </div>
    </li>
  </div>
</template>
<script>
import { downImg } from '@/utils/file'
export default {
  name: 'verifyList',
  props: {
    info: {
      type: Object, // 数据结构 {type: info/img, label： ， value: '', name: }
      required: true
    },
    isAuthentication: Boolean
  },
  methods: {
    lookFullImg(src) {
      if (!src) {
        this.$Message.info('图片未找到')
        return false
      }
      this.$emit('lookFull', src)
    },
    downloadImg(info) {
      const tmp = info.value.split('.')
      const unit = tmp.length !== 0 ? '.' + tmp[tmp.length - 1] : ''
      if (!info.value) {
        this.$Message.info('图片未找到')
        return false
      }
      downImg(info.value, info.name + info.label + unit)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-examine-content {
  width: 50%;
}
.page-examine__renzheng {
  margin-bottom: 20px;
  .page-info-val__name {
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 160px;
  }
  .page-info-val-img {
    display: flex;
    align-items: flex-start;
    .img-ope {
      top: 0;
    }
  }
  .page-info-val__text {
    width: 212px;
  }
}
</style>
